/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function UploadIcon(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'UploadIcon',
      'aria-hidden': true,
      focusable: false,
      width:  20 * scale,
      height: 14 * scale,
      viewBox: '0 0 20 14',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M15.92 5.02a4.5 4.5 0 0 1 .08 8.95V14H4a4 4 0 1 1 0-8 6 6 0 0 1 11.92-.98M11 9h3l-4-5-4 5h3v2h2z"}))
}
